function on(obj, ...args) {
    if (obj && obj.addEventListener) obj.addEventListener(...args);
}
const src_on = on;
export default src_on;
